import React, { useState } from 'react';

const ProfessionalServicesNeomorphicCard = props => {
  const { cardClass, headerText, children, textClass } = props;

  const [showElement, setShowElement] = useState(true);

  const handleFirstCardClick = () => {
    setShowElement(!showElement);
  };

  return (
    <div
      className={`bg-[#F5F5F5] py-[28px] relative z-50 transition-shadow rounded-[12px] h-[433px] w-[245px] overflow-y-auto cursor-pointer ${cardClass}  
          ${
            showElement
              ? 'shadow-[7px_7px_10.3px_0px_rgba(0,0,0,0.11),-10px_-5px_7px_0px_rgba(255,255,255,0.56),2px_-8px_7px_0px_rgba(255,255,255,0.56)]'
              : 'shadow-[2px_-8px_7px_0px_#FFFFFF8F_inset,-10px_-5px_7px_0px_#FFFFFF8F_inset,7px_7px_10.3px_0px_#0000001C_inset]'
          }
        `}
      onClick={handleFirstCardClick}
    >
      {showElement ? (
        <h3 className={`text-center h-full text-[18px] font-[600] flex justify-center items-center ${textClass}`}>{headerText}</h3>
      ) : (
        <p className={'w-full px-[24px] scroll-container overflow-auto h-full text-[12px] font-[300]'}>{children}</p>
      )}
    </div>
  );
};

export default ProfessionalServicesNeomorphicCard;
